<template>
	<page>
		<module title="收支记录详情">
			<c-detail >
				<c-detail-item label="商家" full>
					{{detailData.stationed_name}}
				</c-detail-item>
				<c-detail-item label="收支记录号" >
					{{detailData.record_number}}
				</c-detail-item>
				<c-detail-item label="交易金额" >
					{{detailData.money}}
				</c-detail-item>
				<c-detail-item label="余额" >
					{{detailData.surplus_money}}
				</c-detail-item>
				<c-detail-item label="待结算金额" >
					{{detailData.settle_amount}}
				</c-detail-item>
				<c-detail-item label="收支类型" >
					{{detailData.record_type}}
				</c-detail-item>
				<c-detail-item label="业务流水号" >
					{{detailData.turnover_number}}
				</c-detail-item>
				<c-detail-item label="业务单号" >
					{{detailData.business_number}}
				</c-detail-item>
				<c-detail-item label="收付类型" >
					{{detailData.turnover_type}}
				</c-detail-item>
				<c-detail-item label="业务类型" >
					{{businessTypeName}}
				</c-detail-item>
				<c-detail-item label="会计科目代码">
					{{detailData.account_code}}
				</c-detail-item>
				<c-detail-item label="会计科目">
					{{detailData.account_title}}
				</c-detail-item>
				<c-detail-item label="交易时间">
					{{detailData.create_date}}
				</c-detail-item>
				<c-detail-item label="交易摘要" full>
					{{detailData.remark}}
				</c-detail-item>
			</c-detail>
			
		</module>
		
	</page>
</template>

<script>
	export default {
		name: 'stationed_account_record_detail',
		props: {
			id: String
		},
		data() {
			return {
				detailData: {}
			}
		},
		mounted() {
			this.detail();
		},
		computed: {
			businessTypeName(){
				return {
					1:'销售订单',
					2:'销售退款单',
					3:'销售退货单',
					4:'资金充值',
					5:'资金扣减',
					6:'资金提现'
				}[this.detailData.business_type];
			}
		},
		methods: {
			detail() {
				this.request({
					url: '/stationed/account/record/detail',
					data: {id: this.id},
					loading: true,
					success: data => {
						this.detailData = data;
					}
				});
			}
		}
	}
</script>